/**
 * Inicialización de Firebase y señal de sesión lista.
 *
 * La configuración se lee de variables `VUE_APP_FIREBASE_*` en tiempo de BUILD.
 * El `projectId` debe ser el MISMO que verifica el backend: si no coinciden, todo
 * token se rechaza con 401 aunque el login del cliente parezca correcto.
 */

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
}

/** Instancia de la app de Firebase. */
export const firebaseApp = initializeApp(firebaseConfig)

/** Servicio de autenticación; `auth.currentUser` es la sesión activa o null. */
export const auth = getAuth(firebaseApp)

// Resolves once Firebase has determined the initial auth state (avoids router redirect flicker)
export const authReady = new Promise<void>((resolve) => {
  const unsubscribe = auth.onAuthStateChanged(() => {
    unsubscribe()
    resolve()
  })
})
